import React from 'react';
import { Grid, Typography, withStyles } from '@material-ui/core';
import {
  SelectUI,
  InputUI,
  ImageUI,
  ToggleUI,
  QuillUI,
  CardModuleUI,
} from '../../../common';
import { Config, Validate } from '../../../../other';

const es_mobile = Validate.is_mobile();
const es_iphone = Validate.is_iphone();

const InfoSection_ = (props) => {
  let {
    tienda,
    handleChangeFile,
    handleChange,
    handleChangeSelect,
    handleChangeQuill,
    modalHandler,
    selects,
    classes,
    common,
  } = props;

  return (
    <CardModuleUI>
      <Grid container spacing={24}>
        <Grid item xs={12}>
          <ImageUI
            data={common.fotos}
            max_files={6}
            max_size={10}
            allowed_files={['jpg', 'png', 'jpeg', 'webp']}
            input_allowed_mime="image/jpg,image/jpeg,image/png,image/webp"
            handleChange={handleChangeFile}
            cdn_prefix={Config.CLOUDFRONT_PRODUCTS_CDN}
            upload_path="products"
            row_height={es_mobile ? '100px' : '125px'}
            reducer_max_width={600}
            reducer_max_height={1200}
            xs={4}
            sm={4}
            md={2}
            lg={2}
            z_index={1201}
          />
        </Grid>
        <Grid item xs={12}>
          <InputUI handleChange={handleChange} input={common.p_nombre} />
        </Grid>
        <Grid item xs={12}>
          <SelectUI
            data={common.idCategorias}
            options={selects.categorias}
            handleChangeSelect={handleChangeSelect}
            value_atribute="idCategorias"
            label_atribute={es_iphone ? 'c_nombre_slash' : 'c_nombre_full'}
          />
          <Typography variant="caption" gutterBottom>
            Opcionalmente puedes elegir categorías secundarias{' '}
            <span
              onClick={() =>
                modalHandler(true, 'categorias_secundarias', false)
              }
              className={classes.text_link}
            >
              aquí
            </span>
            .
          </Typography>
        </Grid>
        <ToggleUI show={tienda.t_mayorista ? true : false}>
          <Grid
            item
            sm={tienda.t_mayorista && tienda.t_productos_digitales ? 6 : 12}
            xs={12}
          >
            <SelectUI
              data={common.p_tipo_venta}
              options={selects.p_tipo_venta}
              handleChangeSelect={handleChangeSelect}
            />
          </Grid>
        </ToggleUI>
        <ToggleUI show={tienda.t_productos_digitales ? true : false}>
          <Grid
            item
            sm={tienda.t_mayorista && tienda.t_productos_digitales ? 6 : 12}
            xs={12}
          >
            <SelectUI
              data={common.p_producto_digital}
              options={selects.p_producto_digital}
              handleChangeSelect={handleChangeSelect}
            />
          </Grid>
        </ToggleUI>
        <Grid item xs={12}>
          <QuillUI
            contenido={common.p_descripcion.value}
            placeholder="Descripción de tu producto..."
            handleChangeQuill={handleChangeQuill}
          />
        </Grid>
      </Grid>
    </CardModuleUI>
  );
};

const styles = (theme) => ({
  text_link: {
    color: 'inherit',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
});

export const InfoSection = withStyles(styles, { withTheme: true })(
  InfoSection_
);
